package oldcomponents.rules

import oldcomponents.dropdownSelect
import react.dom.div
import react.dom.label
import react.fc
import react.useEffect
import react.useState
import ru.it_mozaika.sender.common.models.Rule


external interface EmailCampaignRuleProps : RuleProps<Rule.EmailCampaign> {
    var campaigns: Map<String, String>
}

val emailCampaignRule = fc<EmailCampaignRuleProps> { props ->

    var notValue by useState(false)
    useEffect(props.item) {
//        notValue = props.item.not
    }

    val statuses = mapOf(
        0 to "Отправлено",
        2 to "Доставлено",
//        3 to "Ошибка",
        4 to "Открыто",
        5 to "Переешли по ссылке",
    )

    div("form-group row d-flex align-items-center mb-1 pl-2") {
        label("col-3 form-control-label") { +"Кампания:" }
        div("col-2 p-0") {
            child(dropdownSelect) {
                attrs {
                    dropdownOpenDefault = false
                    multiSelect = false
                    showFilter = false
                    currentValue = mapOf(notValue.toString() to if (notValue) "НЕ" else "")
                    selectValues = listOf(false.toString() to "НЕ", true.toString() to "")
                    onSave = {
                        props.onChange(props.item.copy())
                    }
                }
            }
        }
        div("col-2 p-0") {
            child(dropdownSelect) {
                attrs {
                    dropdownOpenDefault = false
                    multiSelect = false
                    showFilter = false
                    currentValue = mapOf()// props.item.status.toString()// .statuses.associate { it.toString() to statuses[it].orEmpty() }
                    selectValues = statuses.map { it.key.toString() to it.value }
                    onSave = { value ->
                        props.onChange(props.item.copy(status = value.keys.first().toInt()))
                    }
                }
            }
        }
        div("col-5 p-0") {
            child(dropdownSelect) {
                attrs {
                    dropdownOpenDefault = false
                    multiSelect = true
                    showFilter = true
                    currentValue = props.item.campaignIds?.associateWith { props.campaigns[it].orEmpty() } ?: emptyMap()
                    selectValues = props.campaigns.map { it.key to it.value }
                    onSave = {
                        props.onChange(props.item.copy(campaignIds = it.keys.toList()))
                    }
                }
            }
        }
    }
}
